module.exports = __webpack_public_path__ + "img/percentage.3ea3ffbb.png";